/* unplugin-vue-components disabled */import script from "./siginRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./siginRecord.vue?vue&type=script&setup=true&lang=js"

import "./siginRecord.vue?vue&type=style&index=0&id=32a88414&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/project/klb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32a88414"]])

export default __exports__